import { render } from "./Cga.vue?vue&type=template&id=9153646e&scoped=true"
import script from "./Cga.vue?vue&type=script&lang=js"
export * from "./Cga.vue?vue&type=script&lang=js"

import "./Cga.vue?vue&type=style&index=0&id=9153646e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9153646e"]])

export default __exports__